export default function VideoPreviewShowcase() {
  return (
    <section className="py-12 px-4 md:px-8 bg-white">
      <h2 className="text-center text-xl font-bold mb-8 text-blue-700">
        {/* Optional Title */}
      </h2>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 justify-center">
        {/* SRK Dress Preview */}
        <div className="mx-auto w-[100%] md:w-[100%] max-h-[550px] overflow-hidden rounded-xl shadow-md">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-contain"
            poster="/images/srktrends-images/srk-dress-thumbnail-1.jpg"
          >
            <source
              src="/srktrends-videos-optimised/IMG_7530_optimized.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        {/* SRK Jewels Preview */}
        <div className="mx-auto w-[100%] md:w-[100%] max-h-[550px] overflow-hidden rounded-xl shadow-md">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-contain"
            poster="/images/srktrends-images/srk-jewels-thumbnail-1.png"
          >
            <source
              src="/srktrends-videos-optimised/IMG_1549_optimized.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </section>
  );
}